<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BVi0c0/tc-custom/9781429933575.jpg?1731797645725" alt="This image is the cover for the book Confederate Gold and Dead Man's Gold"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Confederate Gold and Dead Man's Gold
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Confederate Gold</b><br/><br/>Enoch Brand never met a fight he couldn't resist. His wife Minnie had the same problem with men. Then Minnie finally ran off from Enoch, while the two were headed home to Tennessee. Now Enoch has gone charging after her—running straight into a gun battle, a one-handed ex– Confederate soldier, and a storm of lies, betrayal, and greed that all comes down to one thing: a a fortune waiting to be claimed. The only trouble is, it's killing those who want it most. . .<br/><br/><b>Dead Man's Gold</b><br/><br/>In a remote mining camp in California's rugged Sierra Mountains, a small group of men, women, and children are weathering a slow winter—until a band of trigger-happy, whiskey-slugging thieves comes in search of stolen gold. But what these ruffians didn't count on is having to reckon with the Underhills in a fiery battle that will leave some six feet under…and others rich beyond their wildest dreams.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cameron Judd
      </h2>
      
      <p class="authorDescription body article">Cameron Judd writes with power and authority, and captures the spirit and adventure of America&rsquo;s frontier in his fast-paced, exciting novels. Not since Louis L&rsquo;Amour&rsquo;s Sackett series has a writer brought to life the struggles, tragedies, and triumphs of our early pioneers with such respect and dignity. The author of more than forty books, Judd is one of today&rsquo;s foremost writers of the Old West. He lives with his wife and family in Chuckey, Tennessee.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St Martin's Paperbacks
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bcda3bac